const state = {
  loading: 0
};

const getters = {
  loading: state => state.loading
};

const mutations = {
  startLoading(state) {
    state.loading++;
  },
  finishLoading(state) {
    state.loading--;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters
};
